import useApi from "./useApi";

/**
 * Custon hook for checking the payment status of a job
 */
const usePayment = () => {
    const { getJson } = useApi();

    /**
     * Check the payment status of a transaction
     * 
     * @param {string} transactionId 
     * @param {string} serviceParam 
     * @returns 
     */
    const checkPaymentStatus = async (transactionId, serviceParam = '') => {
        const result = await getJson(`/online/paymentstatus/${transactionId}${serviceParam}`);

        if (result?.authorized !== true) {
            return { result, error: new Error('Payment response unauthorized!') };
        } else {
            return { data: result.authorized };
        }
    }

    return {
        checkPaymentStatus
    }
};


export default usePayment;